import React, { useState } from "react";
import { Form, Modal, Row, Col } from "react-bootstrap";
import Buttons from "react-bootstrap/Button";
import { Button } from "@material-ui/core";
import Cookies from "js-cookie";

import * as Constants from "../../../../constants/Constants";
import { httpPostUpdateAdditionalAccessRequestForVendor } from "../../../../service/httpClient";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import DenyRequest from "../AccessRequests/DenyRequest/DenyRequest";
import "./ApproveDenyRenderer.css";

const ApproveDenyRenderer = (props) => {
  const [approveDeny, setApproveDeny] = useState(false);
  const [vendorConnectionPlatform, setVendorConnection] = useState(null);
  const [errorStatus, seterrorStatus] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");
  const [denyRequestModal, setDenyRequestModal] = useState(false);

  const approveDenyChange = () => {
    setApproveDeny(true);
  };

  const handleClose = () => {
    setApproveDeny(false);
    setVendorConnection(null);
    seterrorStatus(false);
    seterrorMsg("");
  };

  const setVendorConnectionPlatform = (e) => {
    setVendorConnection(e.target.value);
    seterrorStatus(false);
    seterrorMsg("");
  };

  const approveDenyRequest = (requestStatus, reasonReject) => {
    const { data = {} } = props || {};
    const dataToSubmit = {
      id: data?.id,
      duns: data?.duns,
      vendorCorpName: data?.vendorCorpName,
      vendorName: data?.vendorName,
      merchantFirstName: data?.merchantFirstName,
      merchantLastName: data?.merchantLastName,
      merchantEmail: data?.merchantEmail,
      userEmail: data?.userEmail,
      merchandiseType: data?.merchandiseType === "Vendor Direct Fulfillment" ? "VDF"
        : data?.merchandiseType === "Traditional Vendor (Owned Inventory)" ? "Owned Inventory"
          : data?.merchandiseType === "Both" ? "Both"
            : null,
      vendorConnectionPlatform: vendorConnectionPlatform,
      requestType: data?.requestType === Constants.ACCESS_REQUEST ? "ACCESS_REQUEST" :
        data?.requestType === Constants.NEW_VENDOR_RECORD ? "NEW_REQUEST" : "",
      status: requestStatus,
      createdBy: data?.createdBy,
      createdDate: data?.createdDate,
      updatedDate: data?.updatedDate,
      updatedBy: Cookies.get("email"),
      remarks: requestStatus === Constants.REJECTED ? reasonReject : null,
    };

    httpPostUpdateAdditionalAccessRequestForVendor(dataToSubmit)
      .then((res) => {
        if (res?.data?.success) {
          if (requestStatus === Constants.REJECTED) {
            handleCloseDenyRequest();
          } else {
            handleClose();
          }
          props.getAccessRequestDetail();
        }
      })
      .catch((error) => {
        const { message = "" } = error?.response?.data || {};
        seterrorStatus(true);
        seterrorMsg(message);
      });
  };

  const handleCloseDenyRequest = () => {
    setDenyRequestModal(false);
    seterrorStatus(false);
    seterrorMsg("");
  };

  return (
    <>
      {denyRequestModal &&
        <DenyRequest
          show={denyRequestModal}
          approveDenyRequest={approveDenyRequest}
          denyData={props?.data}
          handleCloseDenyRequest={handleCloseDenyRequest}
          errorStatus={errorStatus}
          errorMsg={errorMsg}
        />
      }
      {approveDeny &&
        <>
          <Modal
            contentClassName="approveDenyModal"
            show={approveDeny}
            onHide={handleClose}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {props?.data?.requestType === Constants.ACCESS_REQUEST ?
                  Constants.ACCESS_REQUEST
                  : props?.data?.requestType === Constants.NEW_VENDOR_RECORD ?
                    Constants.NEW_VENDOR_RECORD
                    : ""
                }
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="approveDenyModalBody">
              <Form>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Request Type:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.requestType}</Form.Label>
                </Form.Group>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Company Name:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.vendorCorpName}</Form.Label>
                </Form.Group>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Duns:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.duns}</Form.Label>
                </Form.Group>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Vendor Name:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.vendorName}</Form.Label>
                </Form.Group>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Vendor Email:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.userEmail}</Form.Label>
                </Form.Group>
                <Form.Group className="approveDenyModalBodyFormGroup">
                  <Form.Label className="approveDenyModalBodyFormLabel">Merchant Email:</Form.Label>
                  <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.merchantEmail}</Form.Label>
                </Form.Group>
                {props?.data?.requestType === Constants.NEW_VENDOR_RECORD &&
                  <>
                    <Form.Group className="approveDenyModalBodyFormGroup">
                      <Form.Label className="approveDenyModalBodyFormLabel">Vendor Fulfillment Type:</Form.Label>
                      <Form.Label className="approveDenyModalBodyFormValue">{props?.data?.merchandiseType}</Form.Label>
                    </Form.Group>
                    <Form.Group className="approveDenyModalBodyFormGroup">
                      <Form.Label className="approveDenyModalBodyFormLabel">Vendor Connection Type:</Form.Label>
                      <select
                        className="approveDenyModalBodyFormValue"
                        value={vendorConnectionPlatform !== null && vendorConnectionPlatform}
                        onChange={(e) => setVendorConnectionPlatform(e)}
                      >
                        <option selected hidden>Select</option>
                        <option value="chub">Commerce Hub</option>
                        <option value="directEdi">Direct EDI</option>
                        <option value="directEdiRDS">Direct EDI RDS</option>
                      </select>
                    </Form.Group>
                  </>
                }
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Row className="approveDenyModalFooterRow">
                <Col>
                  <Buttons
                    className="button-later-md"
                    onClick={() => {
                      setDenyRequestModal(true),
                      handleClose()
                    }}
                  >
                    {Constants.DENY_BUTTON}
                  </Buttons>
                </Col>
                <Col>
                  <Buttons
                    className="button-primary-md"
                    disabled={(props?.data?.requestType === Constants.NEW_VENDOR_RECORD && vendorConnectionPlatform === null)}
                    onClick={() => approveDenyRequest(Constants.APPROVED)}
                  >
                    {Constants.APPROVE_BUTTON}
                  </Buttons>
                </Col>
              </Row>
              <Row className="approveDenyModalFooterRow">
                <Col>
                  {errorStatus && (
                    <OnSubmitErrorMessage
                      type="error"
                      message={errorMsg}
                    />
                  )}
                </Col>
              </Row>
            </Modal.Footer>
          </Modal>
        </>
      }
      <Button
        id="approveDenyButton"
        className="button-primary-md approveDenyButton"
        onClick={() => approveDenyChange()}
      >
        {Constants.APPROVE_DENY}
      </Button>
    </>
  );
};

export default ApproveDenyRenderer;
